function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h24v24H0z"
}), React.createElement("path", {
  fill: "#12123B",
  d: "M19 19h-3v-5.3a1.5 1.5 0 00-3 0V19h-3v-9h3v1.2c.5-.84 1.59-1.4 2.5-1.4a3.5 3.5 0 013.5 3.5V19zM6.5 8.31a1.81 1.81 0 110-3.62 1.81 1.81 0 010 3.62zM8 19H5v-9h3v9zM20 2H4c-1.11 0-2 .89-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2z"
}));

var SvgIcLinkedin = function SvgIcLinkedin(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPgogICAgICAgIDxwYXRoIGZpbGw9IiMxMjEyM0IiIGQ9Ik0xOSAxOWgtM3YtNS4zYTEuNSAxLjUgMCAwIDAtMyAwVjE5aC0zdi05aDN2MS4yYy41LS44NCAxLjU5LTEuNCAyLjUtMS40YTMuNSAzLjUgMCAwIDEgMy41IDMuNVYxOXpNNi41IDguMzFhMS44MSAxLjgxIDAgMSAxIDAtMy42MiAxLjgxIDEuODEgMCAwIDEgMCAzLjYyek04IDE5SDV2LTloM3Y5ek0yMCAySDRjLTEuMTEgMC0yIC44OS0yIDJ2MTZhMiAyIDAgMCAwIDIgMmgxNmEyIDIgMCAwIDAgMi0yVjRhMiAyIDAgMCAwLTItMnoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIcLinkedin as ReactComponent };